export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Total images generated',
        cost: 'Cost',
        imagesPerDay: 'Images/day',
    },
};
